/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TaskStatus {
    PENDING = 'PENDING',
    IN_PROGRESS = 'IN_PROGRESS',
    CANCELLED = 'CANCELLED',
    ERROR = 'ERROR',
    DONE = 'DONE',
}
